module.exports = function(data) {
var __t, __p = '';
__p += '<div class="pie">\n    <div class="row pie-widget-body">\n        <div class="col-xs-6 card-chart">\n            <div class="chart">\n\n            </div>\n        </div>\n        <div class="col-xs-6 card-list">\n\n        </div>\n    </div>\n</div>\n';
return __p
}